(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function moveModalsToBody() {
    document.querySelectorAll('[data-notify-me-modal]').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveModalsToBody);
  } else {
    moveModalsToBody();
  }

  var variantsCache = {};
  var maxInstallmentsCache = {};

  function getVariantsData(productId) {
    if (variantsCache[productId]) return variantsCache[productId];
    var script = document.querySelector('[data-notify-me-variants="' + productId + '"]');
    if (!script) return null;
    try {
      variantsCache[productId] = JSON.parse(script.textContent);
      maxInstallmentsCache[productId] = script.getAttribute('data-max-installments');
      return variantsCache[productId];
    } catch (err) {
      return null;
    }
  }

  function getSelectedVariantId() {
    var variantInput = document.querySelector('input[name="id"]') || document.querySelector('select[name="id"]');
    return variantInput ? Number(variantInput.value) : null;
  }

  function updateModalVariant(productId, variant) {
    var modal = document.getElementById('notify-me-modal-' + productId);
    if (!modal) return;

    var titleEl = modal.querySelector('[data-notify-me-variant-title]');
    var priceEl = modal.querySelector('[data-notify-me-variant-price]');
    var installmentsEl = modal.querySelector('[data-notify-me-variant-installments]');
    var variantInput = modal.querySelector('[data-notify-me-variant-input]');

    if (titleEl) titleEl.textContent = variant.label;
    if (priceEl) priceEl.textContent = variant.price;
    if (installmentsEl) {
      installmentsEl.hidden = !variant.installments;
      if (variant.installments) {
        var maxInstallments = maxInstallmentsCache[productId];
        installmentsEl.textContent = 'em até ' + maxInstallments + 'x de ' + variant.installments;
      }
    }
    if (variantInput) variantInput.value = variant.id;
    resetNotifyMeForm(modal);
  }
  function updateNotifyMeState() {
    var selectedVariantId = getSelectedVariantId();
    if (selectedVariantId === null) return;

    document.querySelectorAll('[data-notify-me-trigger]').forEach(function (trigger) {
      var productId = trigger.getAttribute('data-notify-me-trigger');
      var variants = getVariantsData(productId);
      if (!variants) return;

      var variant = variants.find(function (v) { return v.id === selectedVariantId; });
      if (!variant) return;

      trigger.hidden = variant.available;
      updateModalVariant(productId, variant);

      var buyButtonsWrapper = document.querySelector('[data-notify-me-buybuttons="' + productId + '"]');
      if (buyButtonsWrapper) buyButtonsWrapper.hidden = !variant.available;

      var installmentsEl = document.querySelector(
        '#notify-me-modal-' + productId + ' [data-notify-me-variant-installments]'
      );
      if (installmentsEl) installmentsEl.hidden = !variant.installments;

      var titleEl = document.querySelector(
        '#notify-me-modal-' + productId + ' [data-notify-me-variant-title]'
      );
      if (titleEl) titleEl.hidden = !variant.label;

      if (variant.available) {
        var modal = document.getElementById('notify-me-modal-' + productId);
        if (modal && !modal.hidden) closeModal(modal);
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="id"]') || event.target.matches('select[name="id"]')) {
      updateNotifyMeState();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateNotifyMeState);
  } else {
    updateNotifyMeState();
  }

  function openModal(modal) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('notify-me-modal-open');
    var input = modal.querySelector('[data-notify-me-input]');
    if (input) input.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('notify-me-modal-open');
  }

  function setInvalid(field, errorEl, isInvalid) {
    field.classList.toggle('is-invalid', isInvalid);
  }

  function setLoading(submit, isLoading) {
    submit.disabled = isLoading;
    submit.dataset.loading = isLoading ? 'true' : 'false';
  }

  function showSuccess(form) {
    var field = form.querySelector('[data-notify-me-field]');
    var submit = form.querySelector('[data-notify-me-submit]');
    var success = form.querySelector('[data-notify-me-success]');

    field.hidden = true;
    submit.hidden = true;
    success.hidden = false;
  }

  function resetNotifyMeForm(modal) {
    var field = modal.querySelector('[data-notify-me-field]');
    var submit = modal.querySelector('[data-notify-me-submit]');
    var success = modal.querySelector('[data-notify-me-success]');
    var input = modal.querySelector('[data-notify-me-input]');
    var error = modal.querySelector('[data-notify-me-error]');

    if (field) field.hidden = false;
    if (submit) submit.hidden = false;
    if (success) success.hidden = true;
    if (input) input.value = '';
    if (field) field.classList.remove('is-invalid');
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('[data-notify-me-form]')) return;
    event.preventDefault();

    var input = form.querySelector('[data-notify-me-input]');
    var field = form.querySelector('[data-notify-me-field]');
    var error = form.querySelector('[data-notify-me-error]');
    var submit = form.querySelector('[data-notify-me-submit]');
    var email = (input.value || '').trim();

    if (!EMAIL_RE.test(email)) {
      setInvalid(field, error, true);
      input.focus();
      return;
    }

    setInvalid(field, error, false);
    setLoading(submit, true);


    var modal = form.closest('[data-notify-me-modal]');
    var variantInput = modal.querySelector('[data-notify-me-variant-input]');

    fetch('https://worker.vamboracoders.cloud/fn/inscrever-avise-me', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Function-Key': '944ea653-79d9-4644-bdc6-ef9de38f083f'
      },
      body: JSON.stringify({
        email: email,
        variantId: variantInput.value
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro ' + response.status);
        showSuccess(form);
      })
      .catch(function (err) {
        console.error('notify-me:', err);
        alert('Não foi possível salvar. Tente novamente.');
      })
      .finally(function () {
        setLoading(submit, false);
      });

      setLoading(submit, false);
      showSuccess(form);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-notify-me-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-notify-me-open'));
      if (modal) openModal(modal);
      return;
    }

    var closer = event.target.closest('[data-notify-me-close]');
    if (closer) {
      var modalToClose = closer.closest('[data-notify-me-modal]');
      if (modalToClose) closeModal(modalToClose);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModals = document.querySelectorAll('[data-notify-me-modal]:not([hidden])');
    openModals.forEach(closeModal);
  });

  document.addEventListener('submit', handleSubmit);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches('[data-notify-me-input]')) return;
    var field = input.closest('[data-notify-me-field]');
    if (field && field.classList.contains('is-invalid') && EMAIL_RE.test(input.value.trim())) {
      field.classList.remove('is-invalid');
    }
  });
})();